import { get } from "lodash"

const linkTransformer = (link) => {
  const label =
    get(link, "elements.link_label.value") || get(link, "elements.label.value")
  const openInNewWindow =
    get(link, "elements.open_in_new_window.value[0].name") ||
    get(link, "elements.open_in_new_window.value[0].codename")

  return {
    to:
      get(
        link,
        "elements.link_to.value[0].resolved_url"
      ) ||
      get(link, "elements.link_to.value[0].elements.url.value") ||
      get(link, "elements.url.value"),
    openInNewWindow:
      openInNewWindow && openInNewWindow.toLowerCase() === "yes" ? true : false,
    label: label,
  }
}

export default linkTransformer
